'use client'

import type { ReactElement } from 'react'
import cn from 'classnames'
import Link from 'next/link'
import { type Locale } from '@/src/lib/link'

import GlobeIcon from './globe-icon.svg'
import EnglishFlag from './flags/english.svg'
import PortugueseFlag from './flags/portuguese.svg'
import FrenchFlag from './flags/french.svg'
import SpanishFlag from './flags/spanish.svg'

import { isLocaleActive } from '../utils'

import styles from './index.module.scss'
import { formatLocalLink } from '@/src/lib/link'
import { useLocale } from 'next-intl'
import { useSearchParams } from 'next/navigation'

type LocaleOption = {
  text: string
  locale: Locale
  flag: ReactElement
}

const localeOptions: LocaleOption[] = [
  { text: 'English', locale: 'en', flag: <EnglishFlag /> },
  { text: 'Portuguese', locale: 'pt', flag: <PortugueseFlag /> },
  { text: 'French', locale: 'fr', flag: <FrenchFlag /> },
  { text: 'Spanish', locale: 'es', flag: <SpanishFlag /> },
]

export default function LocaleSwitcher() {
  const locale = useLocale()
  const searchParams = useSearchParams()
  const flow = searchParams.get('flow')
  const stage = searchParams.get('stage')

  return (
    <div className={cn(styles.trigger)}>
      <GlobeIcon className={cn(styles.icon)} />

      <ul className={cn(styles.switcher)}>
        {localeOptions.map((option) => {
          const qs = new URLSearchParams()
          if (flow) qs.set('flow', flow)
          if (stage) qs.set('stage', stage)
          const query = qs.toString()
          const path = query ? `/?${query}` : '/'
          const href = formatLocalLink(path, option.locale)
          if (!href) return null

          return (
            <li
              key={option.locale}
              className={cn(styles.item, isLocaleActive(locale, option.locale) && styles.active)}
            >
              <Link href={href}>
                {option.flag}
                <span>{option.text}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
